import React, { useEffect, useState } from "react";
import { Alert, SideMenuPage, WebRoute } from "@intech/web-ui";
import { Session } from "@intech/react-service";

import { routes } from "../../routes";
import packageJson from "../../../package.json";
import config from "../../config.json";

import "./index.scss";
import { useHistory } from "react-router-dom";
import {
  UsuarioService,
  LGPDService,
  FuncionarioService,
} from "../../services";
import { buscarBloqueio, NumFuncionalidade } from "./../../helpers/BloqueioFuncionalidade";

interface IProps {
  title?: string;
  Funcionalidade?: NumFuncionalidade;
  //loading: boolean;
}

export const MasterPage: React.FC<IProps> = ({
  title,
  Funcionalidade,
  ...rest
}) => {
  const history = useHistory();

  const [nome, setNome] = useState("");
  const [admin, setAdmin] = useState(false);
  const [Routes, setRoutes] = useState<WebRoute[]>([]);
  const [MotivoBloqueio, setMotivoBloqueio] = useState<string>("");
  const [Erro, setErro] = useState<string>("");

  useEffect(() => {
    (async () => {
      if (Funcionalidade !== undefined)
        setMotivoBloqueio(await buscarBloqueio(Funcionalidade));
    })();
  }, []);

  useEffect(() => {
    (async () => {
      const menu = await UsuarioService.Menu();
      const filteredRoutes = routes.filter(r => !menu.includes(r.id));
      setRoutes(filteredRoutes);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      try {
        var token = await localStorage.getItem(`@${config.appName}:token`);

        if (token) {
          var admin = await UsuarioService.VerificarAdmin();
          var termo = await LGPDService.Buscar(1);

          if (termo.length === 0 && !admin) {
            history.push("/termos");
          } else {
            var dados = await FuncionarioService.Buscar();
            var nomeUsuario = dados.DadosPessoais.NOME_ENTID;

            if (
              !admin &&
              dados.Usuario &&
              dados.Usuario.IND_PRIMEIRO_ACESSO === "S"
            ) {
              setTimeout(() => history.push("/primeiroAcesso"), 500);
            } else {
            }

            setNome(nomeUsuario);
            setAdmin(admin);
          }
        } else {
          await Session.clear();
          history.push("/login");
        }
      } catch (err) {
        if (err.message.indexOf("401") > -1) {
          await Session.clear();
          history.push("/login");
        } else {
          const error = err.response ? err.response.data : err;
          if (error !== "") {
            setErro(error);
          }
          console.error(err);
        }
      }
    })();
  }, []);

  if (MotivoBloqueio !== "") {
    return (
      <SideMenuPage
        admin={admin}
        loading={false}
        logo={require("../../assets/logo.png")}
        routes={Routes}
        userComponent={null}
        username={nome}
        version={packageJson.version}
        title={title}
        {...rest}
      >
        <Alert type={"danger"}>
          {MotivoBloqueio}
        </Alert>
      </SideMenuPage>
    );
  }

  if (Erro !== "") {
    return (
      <SideMenuPage
        admin={admin}
        loading={false}
        logo={require("../../assets/logo.png")}
        routes={Routes}
        userComponent={null}
        username={nome}
        version={packageJson.version}
        title={title}
        {...rest}
      >
        <Alert type={"danger"}>
          {Erro}
        </Alert>
        {rest.children}
      </SideMenuPage>
    );
  }

  return (
    <SideMenuPage
      admin={admin}
      loading={false}
      logo={require("../../assets/logo.png")}
      routes={Routes}
      userComponent={null}
      username={nome}
      version={packageJson.version}
      title={title}
      {...rest}
    />
  );
};
